<template>
	<v-main>
		<v-form ref="form" v-model="valid" @submit.prevent="changePassword()" class="pa-4">
			<v-row class="d-flex justify-center align-center">
				<v-col cols="12" sm="6">
					<v-alert v-model="alert.show" :type="alert.type" dismissible>{{alert.message}}</v-alert>
					<v-text-field
						v-model="currentPassword"
						:rules="[(v) => !!v || 'Please specify your current password']"
						:type="passwordFieldType"
						:append-icon="passwordFieldType === 'password' ? 'mdi-eye' : 'mdi-eye-off'"
						@click:append="switchVisibility1"
						label="Current Password"
						dense
						rounded
						filled
						required
					></v-text-field>
					<v-text-field
						v-model="newPassword"
						:rules="[(v) => !!v || 'Please specify a new password']"
						:type="newPasswordFieldType"
						:append-icon="newPasswordFieldType === 'password' ? 'mdi-eye' : 'mdi-eye-off'"
						@click:append="switchVisibility2"
						label="New Password"
						dense
						rounded
						filled
						required
					></v-text-field>
					<v-text-field
						v-model="confirmNewPassword"
						:rules="[v => (!!v || 'Please confirm your new password'), v => ((v && v === newPassword) || 'New password does not match confirm new password')]"
						:type="confirmPasswordFieldType"
						:append-icon="confirmPasswordFieldType === 'password' ? 'mdi-eye' : 'mdi-eye-off'"
						@click:append="switchVisibility3"
						label="Confirm New Password"
						dense
						rounded
						filled
						required
					></v-text-field>
				</v-col>
			</v-row>
			<v-row class="d-flex justify-center align-center">
				<v-btn :disabled="!valid" class="v-unite-primary px-8" type="submit" rounded>Save</v-btn>
			</v-row>
		</v-form>
	</v-main>
</template>

<script>
import axios from "axios";

export default {
	data() {
		return {
			valid: true,
			currentPassword: null,
			newPassword: null,
			confirmNewPassword: null,
			alert: { show: false, message: "" },
			baseLocation: axios.defaults.baseURL,
			passwordFieldType: "password",
			newPasswordFieldType: "password",
			confirmPasswordFieldType: "password",
		};
	},
	methods: {
		changePassword() {
			this.alert.show = false;
			axios
				.post("/system/user/changepassword", {
					currentPassword: this.currentPassword,
					newPassword: this.newPassword,
					confirmNewPassword: this.confirmNewPassword
				})
				.then(() => {
					[this.alert.type, this.alert.message, this.alert.show] = ["success", "Your password has been changed", true];
					this.$refs.form.reset();
				})
				.catch(() => {});
		},
		switchVisibility1() {
			this.passwordFieldType = this.passwordFieldType === "password" ? "text" : "password";
		},
		switchVisibility2() {
			this.newPasswordFieldType = this.newPasswordFieldType === "password" ? "text" : "password";
		},
		switchVisibility3() {
			this.confirmPasswordFieldType = this.confirmPasswordFieldType === "password" ? "text" : "password";
		},
	}
};
</script>